export default __webpack_public_path__ + "static/media/py.c9084660.svg";